import { get, post } from './fetch'

export const getFailedCommissionPayments = () => {
    return get(`/api/seller/commission/failed-payments`);
}

export const getFailedCommissionPaymentsCount = () => {
    return get(`/api/seller/commission/failed-payments/count`);
}

export const updateExistingCommissionPayment = (reqParams) => {
    return post(`/api/seller/subscription/commission/payment`, reqParams, true);
}